const VET = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="10" cy="10" r="10" fill="#55BBF9" />
    <path
      d="M14.8701 5.75014H14.6587C14.5496 5.75014 14.45 5.81211 14.4017 5.91003L10.9197 12.9624C10.6446 13.5196 9.87948 13.5911 9.50622 13.0943L9.29987 12.8197L9.18184 12.6439L5.94448 6.05911L5.83452 5.89028C5.77752 5.80278 5.68025 5.75 5.5759 5.75H3.9156C3.76385 5.75 3.67075 5.91649 3.75004 6.04604L3.82385 6.16678L8.33351 15.2793L8.52841 15.703C8.85921 16.4222 9.87517 16.4352 10.2242 15.7247L15.0124 5.97904C15.0642 5.87352 14.9875 5.75014 14.8701 5.75014Z"
      fill="white"
    />
  </svg>
);
export default VET;
